import React from 'react';
import { FlatList } from 'react-native';
import { t } from '@lingui/macro';
import { useNavigation } from '@react-navigation/native';
import styled from 'styled-components/native';

import HeadTourPlus from '@src/components/HeadTourPlus';
import Separator from '@src/components/Separator';
import Title from '@src/components/Title';
import TourPlusModal from '@src/components/TourPlusCard';
import TourSummeryCard from '@src/components/TourSummeryCard';
import { idKeyExtractor, padding } from '@src/configuration/constants';
import useLanguage from '@src/hooks/useLanguage';
import useTours from '@src/hooks/useTours';
import { i18n } from '@src/i18n';
import { PageItemAPI, TourSummery } from '@src/types';

type Props = {
  data: PageItemAPI;
};

const Container = styled.View<{ tourType: string }>`
  width: 100%;
  padding-top: 12px;
  background-color: ${({ tourType, theme }) =>
    tourType === '' ? theme.colors.backPlus : 'transparent'};
`;
const Touchable = styled.TouchableOpacity`
  margin: 1px 0px;
`;
export const ToursList = styled(
  FlatList as new () => FlatList<TourSummery>
).attrs(() => ({
  horizontal: true,
  removeClippedSubviews: true,
  initialNumToRender: 10,
  keyExtractor: idKeyExtractor,
  showsHorizontalScrollIndicator: false,
  ItemSeparatorComponent: Separator,
  contentContainerStyle: {
    paddingHorizontal: padding,
    paddingVertical: padding,
    minHeight: 194,
  },
}))``;
const Component: React.FC<Props> = (props) => {
  const {
    data: { name, url, params },
  } = props;

  const language = useLanguage();
  const tours = useTours(url, params);
  const navigation = useNavigation();
  const [tourPlusVisible, setTourPlusVisible] = React.useState(false);
  const title = React.useMemo(() => name?.[language] ?? '', [language, name]);
  const isPlusTour = React.useMemo(() => url.indexOf('284') !== -1, [url]);
  const handleViewMorePress = React.useCallback(() => {
    navigation.navigate('Tours', { title, url, params });
  }, [navigation, params, title, url]);

  return (
    <Container tourType={isPlusTour ? '' : 'has'}>
      <Separator />
      <Title
        onMorePress={handleViewMorePress}
        titleSuffixPlus={isPlusTour ? i18n._(t`Youtopin`) : ''}
      >
        {isPlusTour ? i18n._(t`Standard Tours`) : title}
      </Title>
      <ToursList
        data={tours.data}
        renderItem={({ item }) => <TourSummeryCard item={item} isHome={true} />}
      />
      <Touchable onPress={() => setTourPlusVisible(true)}>
        {isPlusTour && (
          <HeadTourPlus
            children={i18n._(t`About Tours`)}
            titleSuffixPlus={i18n._(t`More Know`)}
            titlePlus={i18n._(t`Standard`)}
            popUp
          />
        )}
      </Touchable>
      <TourPlusModal
        visible={tourPlusVisible}
        onDismiss={() => setTourPlusVisible(false)}
      />
    </Container>
  );
};

Component.displayName = 'TourItems';

export default React.memo(Component);
